import { Spinner } from '@guestyci/arc';

const SuspenseLoader = () => {
  return (
    <div className="gst-flex gst-h-full gst-w-full gst-items-center gst-justify-center gst-border gst-border-solid gst-border-gray-300 gst-rounded-lg">
      <Spinner size="lg" />
    </div>
  );
}

export default SuspenseLoader;